import LoginBanner from "components/shared/LoginBanner";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../redux/slice/auth.slice";
import Authenticate from "./designs/Authenticate";
import LoginForm from "./designs/LoginForm";

const Login = () => {
  const dispatch = useDispatch();
  const loginTab = useSelector(authActions.selectors.getLoginTab);
  const setTab = (tab) => {
    dispatch(authActions.actions.setLoginTab(tab))
  }
  const rendered = (val) => {
    switch (val) {
      case 0:
        return <LoginForm/>;
      case 1:
        return <Authenticate setTab={() => setTab(2)} />;
      default:
        return <LoginForm />;
    }
  }
  return (
    <div className="grid grid-cols-1 bg-[#F2F2F2]  md:grid-cols-2">
      {rendered(loginTab)}
      <LoginBanner />
    </div>
  );
};

export default Login;
